const colors = {
  primary: "#08ed71",
  secondary: "#0a4243",
  white: "#ffffff",
  background: "#0a4243",
  text: "#fff",
  hoverBackground: "rgba(255, 255, 255, 0.08)",
  hoverButton: "#54f79f",
  mainContentBgColor: "#eaeff1",
  btnBackgroundColorOnHover: "#1e4e4f",
};

export default colors;
